import type { DocumentRepository } from "../repositories/document-repository"

export const makeCancelDocument = (repo: DocumentRepository) =>
  (docId: string) =>
    repo.cancel(docId)
